import {Icon} from '../../../shared/components/icon';

export const icons: {[key: string]: Icon} = {
    Artifact: 'file-alt',
    Collapsed: 'ellipsis-h',
    Error: 'times',
    Failed: 'times',
    Omitted: 'forward',
    Pending: 'clock',
    Running: 'circle-notch',
    Skipped: 'forward',
    Succeeded: 'check',
    Suspended: 'pause',
    Memoized: 'database'
};
